/*
 * Copyright (C) 2026 to Present Applause App Quality, Inc. All rights reserved.
 */

import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  ViewEncapsulation,
  inject,
  signal,
} from '@angular/core';
import { DelightSupportService } from '@ng-falcon/delight-support/delight-support.service';
import { NotificationService } from '@ng-falcon/notification/notification.service';
import { NotificationType } from '@ng-falcon/notification/notification-type';
import { NotificationConfig } from '@ng-falcon/notification/notification-config';
import {
  TESTER_NAVIGATION_HEADER_SERVICE,
  TesterNavigationHeaderService,
} from '../tester-navigation-header.service';

@Component({
  selector: 'ngf-tester-navigation-header-support',
  templateUrl: './tester-navigation-header-support.component.html',
  styleUrls: ['./tester-navigation-header-support.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [],
})
export class TesterNavigationHeaderSupportComponent implements OnInit {
  private readonly navHeaderService: TesterNavigationHeaderService = inject(TESTER_NAVIGATION_HEADER_SERVICE);
  private readonly supportChatService = inject(DelightSupportService);
  private readonly notificationService = inject(NotificationService);

  readonly isTester = signal(false);
  readonly chatLoading = signal(false);

  ngOnInit(): void {
    this.navHeaderService.getCurrentUser().then((user) => {
      this.isTester.set(user?.isTester === true);
    });
  }

  async toggleSupportChat(): Promise<void> {
    if (this.supportChatService.hasMessengerInstance) {
      this.supportChatService.openMessenger();
      return;
    }

    this.chatLoading.set(true);

    const chatLaunched = await this.supportChatService.launchChat();

    this.chatLoading.set(false);

    if (!chatLaunched) {
      this.notificationService.show<NotificationConfig>({
        text: 'Failed to launch support chat. Please try again later.',
        type: NotificationType.DANGER,
        lifetime: -1,
      });
    }
  }
}
